import { apiCall } from 'api';
import { EPG_LINEUP_SERVICE } from './paths';

export const fetchLineUpData = params =>
  apiCall.get(EPG_LINEUP_SERVICE, { params });
